// --- Science Direct Technology ---

import React from 'react';
import PropTypes from 'prop-types';

function LoadingSpinner({
  show,
}) {
  return (
    <div className="LoadingSpinner" style={{ display: show ? 'block' : 'none' }}>
      <div className="double-bounce1" />
      <div className="double-bounce2" />
    </div>
  );
}

LoadingSpinner.propTypes = {
  show: PropTypes.bool,
};

export default LoadingSpinner;
